<template>
  <div>
    <div class="flex justify-end">
      <button
        type="button"
        class="flex items-center justify-center px-4 py-2 mr-4 bg-[#EDF1F5] rounded-lg border-t border-l border-r border-solid border-[#707c8e26]"
        @click="toggleExpand"
      >
        <span class="text-[#656F7E] font-inter">GRI Licensing Disclaimer</span>
        <ChevronDownSmall
          :class="{ 'rotate-180': !isExpanded }"
          :custom-style="`ml-2 h-6 w-6 mt-1 text-[#656F7E] transition-transform duration-200`"
        />
      </button>
    </div>
    <div
      v-if="isExpanded"
      class="flex flex-col max-h-1/5 sm:flex-row bg-[#EDF1F5] p-4 border-t border-solid border-[#707c8e26]"
    >
      <div class="px-2 py-5">
        <NuxtImg
          src="/GRI.png"
          alt="GRI image"
          class="w-full h-auto max-w-sm"
        />
      </div>
      <div class="w-full p-5 pt-0 pb-0 sm:pt-5">
        <p class="text-[#68737D] font-inter text-justify leading-tight text-sm 2xl:text-md">
          The GRI Standards are used by Zuno Carbon under licensed authority from GRI. GRI, as Licensor of the copyright
          in the GRI Standards, verified and validated the authentic and accurate representation of the GRI Standards in
          Veridis. This verification was limited to ensuring the maintenance
          of the integrity, authenticity and accuracy of the Licensed Content. GRI therefore makes no implied or actual
          representations or warranties as to the correctness, compliance, trustworthiness, fitness of purpose or
          quality of Veridis or any products resulting therefrom; or of Licensee’s use
          of the GRI copyrighted content; and expressly disclaims any implied or express representations that any report
          produced by Licensee meets the standards of an approved GRI Standards Report.
        </p>
        <p class="text-[#68737D] font-inter py-2 text-justify leading-tight text-sm 2xl:text-md">
          The questions in the GRI Reporting Framework are derived from the clauses of the GRI Standards. For complete
          requirements, please download the full set of
          <a
            href="https://www.globalreporting.org/how-to-use-the-gri-standards/gri-standards-english-language/"
            target="_blank"
            class="font-semibold text-purple-700 hover:underline"
          > GRI Standards.</a>
        </p>
        <p class="text-[#68737D] font-inter text-justify pb-3 leading-tight text-sm 2xl:text-md">
          For the latest version of the GRI Standards, including the revised Universal Standards, adapted Topic
          Standards, Sector Standards, their recommendations and guidance sections, as well as the GRI Standards
          Glossary, please visit the GRI Resource center:
          <a
            href="https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center/"
            class="underline"
          >https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center/</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GRIBanner',
  data() {
    return {
      isExpanded: false,
    }
  },
  mounted() {
    const bannerState = localStorage.getItem('banner_state')
    this.isExpanded = bannerState === 'true'
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      localStorage.setItem('banner_state', this.isExpanded.toString())
    },
  },
}
</script>
